
        import * as module0 from '$components/shared/met_you.js';import * as module1 from '$components/shared/problem_nav.js'
        const modules = {
            "shared/met_you.js": module0,
            "shared/problem_nav.js": module1,
        };
        export default modules;
      